/**
 * Returns the current version.
 * @param {"year" | "full"} [format="full"] - Format of the version. If "year", returns only the year. If "full", returns the full version.
 * @returns {string} Version in sepcified format.
 */
export const getCurrentVersion = (format: "year" | "full" = "full") => {
  const version = "0.97.30";
  const year = "2019-25";
  switch (format) {
    case "year":
      return year;
    case "full":
      return `${version} ${year}`;
  }
};
